import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, PLATFORM_ID } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-solutions-crypto-exchange',
  imports: [MatIcon, RouterLink, RelatedPagesComponent],
  templateUrl: './crypto-exchange.component.html',
  styleUrl: './crypto-exchange.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionsCryptoExchangeComponent {
  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/aml-check',
      anchor: "Online AML check",
      text: "The check itself: one address or transaction, screened against four AML data providers at once.",
    },
    {
      link: '/transaction-monitoring',
      anchor: "Crypto transaction monitoring",
      text: "Keep deposit and withdrawal wallets under continuous watch instead of re-checking them by hand.",
    },
    {
      link: '/aml-api',
      anchor: "AML API",
      text: "Put the same checks inside your own deposit and withdrawal flow through one integration.",
    },
    {
      link: '/pricing',
      anchor: 'Pricing and plans',
      text: 'Pro, Corporate and Enterprise plans, each with all four AML providers through one integration; per-report rates appear in your account after registration.',
    },
  ];

  private readonly _platformId = inject(PLATFORM_ID);

  readonly createAccountHref = computed(() => {
    if (!isPlatformBrowser(this._platformId)) {
      return 'https://app.amlofficer.org/register-corporate-account';
    }

    const referralLink = localStorage.getItem('referralLink');
    const trackingLink = localStorage.getItem('trackingLink');
    const queryParams = new URLSearchParams();
    if (referralLink) {
      queryParams.set('referralLink', referralLink);
    }
    if (trackingLink) {
      queryParams.set('trackingLink', trackingLink);
    }
    const query = queryParams.toString();
    return query
      ? `https://app.amlofficer.org/register-corporate-account?${query}`
      : `https://app.amlofficer.org/register-corporate-account`;
  });
}
